<template>
  <div class="form-container">
    <div class="form-group">
      <form @submit.prevent="createTag">
        <input
          type="text"
          id="tag-name-input"
          class="form-control"
          placeholder="Tag Name"
          autocomplete="off"
          spellcheck="false"
          v-model="tagName"
          @input="error = ''"
          required
        />
        <span
          v-if="!isFieldValid"
          class="info-message">
          Tag name must be at least 3 characters long.
        </span>
        <span class="error-message" v-if="error">{{ error }}</span>
        <button
          type="submit"
          class="btn btn-primary"
          :disabled="!isFieldValid"
        >
          <span>Create Tag</span>
        </button>
      </form>
    </div>
  </div>
</template>
<script>

import createTag from '@/handlers/createTag';

export default {
  props: {
    topic: {
      type: String,
      required: true,
    },
    successCallback: {
      type: Function,
      default: e => e,
    },
  },
  data() {
    return {
      tagName: '',
      error: '',
    };
  },
  computed: {
    isFieldValid() {
      return this.tagName.length >= 3;
    },
  },
  methods: {
    createTag() {
      const input = {
        id: this.tagName.toUpperCase().replace(/\s/g, '-'),
        topic: this.topic,
        name: this.tagName,
      };

      createTag(
        input,
        this.successCallback,
        (error) => { this.error = error.message; },
      );
    },
  },
};
</script>

<style lang="stylus" scoped>
  @require '../style/colors'

  .form-container
    display: flex
    flex-direction: row
    justify-content: center
    align-items: baseline
    padding: 5px 0px
    flex-wrap: wrap;
    gap: 4rem;

    .form-group
      display: flex
      flex-direction: column
      align-items: center
      justify-content: space-between
      margin: 5px 0px

    form
      display: flex
      flex-direction: column
      align-items: center
      justify-content: center
      margin-top: 2rem
      gap: 1rem

      input
        font-size: 1.5rem
        padding: 1.3rem 1.5rem
        border-radius: .5rem
        border: 1px solid $black60
        font-family: space-grotesk

        &:focus
          outline: none
          border: 1px solid $primary-color

      button[type="submit"]
        background-color: $primary-color
        color: $white
        font-size: 1.7rem
        padding: 1.3rem 2.5rem
        border: none
        border-radius: .5rem
        cursor: pointer
        transition: background-color 0.3s ease-in-out

        &:hover
          background-color: darken($primary-color, 10%)

        &:disabled
          /* Disabled state styles */
          background-color: $secondary-color;
          cursor: not-allowed;
  .info-message
  .error-message
    margin: 0.5rem
    margin-bottom: 1.5rem
    font-size: 1.4rem
  .error-message
    background-color: $secondary-color
    color: red
    padding: 1rem
  .info-message
    color: $black60

</style>
